import React from 'react';
import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
    ResponsiveContainer,
  } from 'recharts';

  
  const RelativeComparisionChart = (props) => {
    const resultDetail = props.resultDetail !== undefined && props.resultDetail;
    const subject = resultDetail.subject !==undefined && resultDetail.subject;
    const subjectWiseData = resultDetail.subject_wise_data !==undefined && resultDetail.subject_wise_data
    
    let subjectItem = []
    const data=[]

    let obtain_marks=0;
    let max_marks=0;
    let highestmarks=0;
    let percentage=0;
    let avgmarks=0;
    let percentile=0;
    let bio = []
    let chem = []
    let ma = []



    for (let sub in  subject) {
        let repatevar=[];
        let alllist=subject[sub];
        // if(subject[sub].fieldvalue.toUpperCase() === 'ZOOLOGY' 
        // || subject[sub].fieldvalue.toUpperCase() === 'BOTANY' 
        // || subject[sub].fieldvalue.toUpperCase() === 'BIOLOGY'
        // || subject[sub].fieldvalue.toUpperCase() === 'IOC'
        // || subject[sub].fieldvalue.toUpperCase() === 'PC'
        // || subject[sub].fieldvalue.toUpperCase() === 'IQ'
        // || subject[sub].fieldvalue.toUpperCase() === 'MENTAL ABILITY'){
        //   continue;
        // }

        repatevar['name']=alllist.fieldvalue;
        repatevar['Your']=alllist.percentage;
        repatevar['Average']=alllist.avgmarks;
        repatevar['amt']=100;
        data.push(repatevar);
    }


    const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
      return <text x={x + width / 2} y={y} fill="#333" textAnchor="middle" dy={-6}>{`${value}%`}</text>;
    };
    const yourCustomBarLabel = ({ payload, x, y, width, height, value }) => {
      return <text x={x + width / 2} y={y} fill="#333" textAnchor="middle" dy={-6}>{`${value}%`}</text>;
    };

    return(
        <ResponsiveContainer width="100%" height={450}>
        <BarChart
          width="100%"
          height={400}
          data={data}
          margin={{
            top: 20,
            right:10,
            left: 10,
            bottom: 20,
            
            
          }}
        >
          {/* <CartesianGrid strokeDasharray="3 0" /> */}
          <XAxis dataKey="name" />
          <YAxis dataKey="amt"/>
          <Tooltip />
          <Legend width={300} wrapperStyle={{ top: -45, right: 30, fontSize: "18px", accentColor:'#000'}}/>
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <Bar barSize={30}  dataKey="Average" fill="#1A3584"  radius={[8,8,0,0]} >
            <LabelList  dataKey="Average"  content={renderCustomBarLabel} />
          </Bar>
          <Bar barSize={30} dataKey="Your" fill="#B5D8FF" radius={[8,8,0,0]}  >
          <LabelList  dataKey="Your" content={yourCustomBarLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    )
  }

  export default RelativeComparisionChart;